import {takeEvery} from 'redux-saga/effects'

import {
  ACTIVATE_USERS,
  ADD_DEVICE_TOKEN,
  CONFIRM_PROFILE_PICTURE_UPLOAD,
  CONFIRM_PROFILE_PICTURE_UPLOAD_ANY_USER,
  GET_ACTIVE_STAFF,
  GET_ALL_ACTIVE_EMPLOYEE_ATTENDANCE,
  GET_ALL_ACTIVE_STUDENTS_ATTENDANCE,
  GET_CHILD_PROFILE,
  GET_PROFILE_PICTURE_UPLOAD_URL,
  GET_PROFILE_PICTURE_UPLOAD_URL_ANY_USER,
  GET_STUDENTS_ATTENDANCE_BY_GRADES,
  GET_STUDENTS_SUBJECT_ATTENDANCE,
  GET_STUDENT_HOUSE_LABEL,
  GET_TEACHERS_SUBJECT_ATTENDANCE,
  GET_USER_MESSAGES,
  GET_USER_PROFILE,
  GET_USER_SETTINGS,
  INACTIVATE_USERS,
  LOGOUT_USERS,
  MOVE_USERS_TO_JUNK,
  REGENERATE_USER_PASSWORDS,
  SEND_FEEDBACK,
  SET_USER_SETTINGS,
  UPDATE_PASSWORD,
  USER_IMPERSONATE,
  VERIFY_PASSWORD,
} from '../../Actions/User/ActionTypes/ApiActionTypes'
import fetchData from '../SagaHelper'

function* dataSaga() {
  yield takeEvery(ADD_DEVICE_TOKEN, fetchData)
  yield takeEvery(SEND_FEEDBACK, fetchData)
  yield takeEvery(SET_USER_SETTINGS, fetchData)
  yield takeEvery(GET_USER_SETTINGS, fetchData)
  yield takeEvery(GET_USER_PROFILE, fetchData)
  yield takeEvery(GET_CHILD_PROFILE, fetchData)
  yield takeEvery(GET_STUDENT_HOUSE_LABEL, fetchData)
  yield takeEvery(GET_ACTIVE_STAFF, fetchData)
  yield takeEvery(GET_USER_MESSAGES, fetchData)
  yield takeEvery(GET_PROFILE_PICTURE_UPLOAD_URL, fetchData)
  yield takeEvery(GET_PROFILE_PICTURE_UPLOAD_URL_ANY_USER, fetchData)
  yield takeEvery(CONFIRM_PROFILE_PICTURE_UPLOAD, fetchData)
  yield takeEvery(GET_ALL_ACTIVE_EMPLOYEE_ATTENDANCE, fetchData)
  yield takeEvery(GET_ALL_ACTIVE_STUDENTS_ATTENDANCE, fetchData)
  yield takeEvery(GET_STUDENTS_SUBJECT_ATTENDANCE, fetchData)
  yield takeEvery(GET_TEACHERS_SUBJECT_ATTENDANCE, fetchData)
  yield takeEvery(CONFIRM_PROFILE_PICTURE_UPLOAD_ANY_USER, fetchData)
  yield takeEvery(ACTIVATE_USERS, fetchData)
  yield takeEvery(INACTIVATE_USERS, fetchData)
  yield takeEvery(MOVE_USERS_TO_JUNK, fetchData)
  yield takeEvery(USER_IMPERSONATE, fetchData)
  yield takeEvery(VERIFY_PASSWORD, fetchData)
  yield takeEvery(UPDATE_PASSWORD, fetchData)
  yield takeEvery(REGENERATE_USER_PASSWORDS, fetchData)
  yield takeEvery(GET_STUDENTS_ATTENDANCE_BY_GRADES, fetchData)
  yield takeEvery(LOGOUT_USERS, fetchData)
}

export default dataSaga
